import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled, { keyframes } from 'styled-components'
import AnimationContainer from 'components/animation-container'
import { Link } from "gatsby"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowLeft, faArrowRight,   
} from '@fortawesome/free-solid-svg-icons'


class Hosting extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #f6f6f6;
            padding: 100px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            flex-wrap: wrap;
            margin-right: -15px;
            margin-left: -15px;
            display: flex;
        `

        const ServiceHeading3 = styled.h3`
            font-size: 18px;
            font-weight: 700;
            color: #212122;
            text-decoration: none !important;
            a   {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #212122;
                transition: color 0.3s ease; /* Agrega una transición suave al cambio de color del hover */

            &:hover {
                color: #e44100; /* Cambia el color al pasar el mouse */
                }
            }

            @media (max-width: 767px) {
            font-size: 16px;
          }
        `
        const ServiceHeading3v = styled.h3`
            font-size: 18px;
            font-weight: 700;
            color: #212122;
            text-decoration: none !important;
            a   {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #212122;
                transition: color 0.3s ease; /* Agrega una transición suave al cambio de color del hover */

            &:hover {
                color: #c1eb18; /* Cambia el color al pasar el mouse */
                }
            }

            @media (max-width: 767px) {
            font-size: 16px;
          }
        `

        const Heading2 = styled.h2`
            font-size: 40px;
            font-weight: 700;
            color: #212122;
            text-align:center;
        `        
        
        const ServiceText = styled.p`
            font-size: 16px;
            line-height: 26px;
            color: #808080;
            margin-top: 5px;
            font-family: 'Open Sans',sans-serif;
            font-weight: normal;
            @media (max-width: 767px) {
              font-size: 14px;
              line-height: 20px;
          }
        `

        const Inform = styled.div`
            width: 72%;
            padding: 10px 30px;
            display: inline-block;
            vertical-align: middle;
        `

        const ServiceWrap = styled.div`            
            font-weight: bold;
            color: #ff6d37;            
        `

        const AnimatedShadow = keyframes`
            0%   {box-shadow: 0 2px 60px rgba(126, 126, 126, .5);}
            10%  {box-shadow: 0 4px 60px rgba(80,115,184, .5);}
            20%  {box-shadow: 0 6px 60px rgba(80,115,184, .5);}
            30%  {box-shadow: 0 10px 60px rgba(126, 126, 126, .5);}
            40% {box-shadow: 0 14px 60px rgba(80, 115, 184, .5);}
            50% {box-shadow: 0 16px 60px rgba(126, 126, 126, .5);}
            60% {box-shadow: 0 18px 60px rgba(62, 62, 62, .5);}
            70% {box-shadow: 0 22px 60px rgba(62, 62, 62, .5);}
            80% {box-shadow: 0 24px 60px rgba(80, 115, 184, .5);}
            90% {box-shadow: 0 26px 60px rgba(16, 152, 173, .5);}
            100% {box-shadow: 0 28px 60px rgba(126, 126, 126, .5);}
            -webkit-transition: all 300ms linear 0ms;
	          -moz-transition: all 300ms linear 0ms;
	          -ms-transition: all 300ms linear 0ms;
	          transition: all 300ms linear 0ms;
            transition: all .3s ease;
        `

        const HelpContainer = styled.div`            
            position: relative;
            height: 145px;
            margin-top: 50px;
            border-radius: 3px;
            background-color: #fff;
            box-shadow: 0 5px 15px 0 rgba(110, 110, 110, .1);
            transition: all .3s ease;
            &:hover {
              background-color: #fff;
              animation: ${AnimatedShadow} 10s infinite alternate;
              transform: translateY(-5px);              
            }
            @media (max-width: 767px) {
              height: 200px;
            }
            @media (min-width:768px) and (max-width:1500px) {
              height: 180px;             
            }
        `

        const Img = styled.div`            
            display: inline-block;
            vertical-align: middle;
            position: relative;
            width: 28%;
            height: 100%;
        `

        const Ico = styled.svg`            
            position: absolute;
            top: 30%;
            left: 30%
        `

        const BadgeGrey = styled.div`
            position: absolute;
            right: auto;
            left: 10px !important;
            display: inline-block;
            padding: .25em .4em;
            background-color: #808080 !important;
            color: #ffffff !important;
            top: 10px;
            z-index: 1;
            font-size: 75%;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: .10rem;
            transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        `

        const BadgeGreyR = styled.div`
            position: absolute;
            right: 10px;            
            display: inline-block;
            padding: .25em .4em;
            background-color: #808080 !important;
            color: #ffffff !important;
            top: 10px;
            z-index: 1;
            font-size: 75%;
            font-weight: 700;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: .10rem;
            transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        `

        return(
          <Section>
            <Container>
              <Col md={12}>
                <Heading2>
                  SSL Colombia
                </Heading2>
              </Col>
              <ServiceWrap>
                <ServiceRow>
                  <Col md={6}>
                    <AnimationContainer animation="fadeInDown" delay={500}>
                      <HelpContainer>
                        <BadgeGrey><FontAwesomeIcon icon={faArrowLeft} size="1x" /></BadgeGrey>                        
                          <Img>
                          <Ico>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 32 32" alt="Certificados SAN SSL">
                              <title>privacy</title>
                              <path fill="#5e686b" d="M31.688 3.688c0-0.188-0.15-0.337-0.337-0.337h-30.756c-0.012 0-0.025 0-0.037 0-0.169 0.019-0.306 0.163-0.306 0.337v24.6c0 0.188 0.15 0.337 0.338 0.337h30.75c0.188 0 0.337-0.15 0.337-0.337v-18.375c0-0.012 0-0.025 0-0.031 0-0.012 0-0.025 0-0.037l0.012-6.156zM31.006 4.031v5.469h-30.069v-5.469h30.069zM0.938 27.95v-17.769h30.069v17.769h-30.069z"></path>
                              <path fill="#5e686b" d="M5.1 8.019c0.75 0 1.356-0.612 1.356-1.362s-0.612-1.362-1.356-1.362c-0.75 0-1.362 0.612-1.362 1.362 0.006 0.756 0.612 1.362 1.362 1.362zM5.1 5.981c0.375 0 0.681 0.306 0.681 0.681s-0.306 0.681-0.681 0.681c-0.375 0-0.681-0.306-0.681-0.681s0.306-0.681 0.681-0.681z"></path>
                              <path fill="#5e686b" d="M9.931 8.019c0.75 0 1.363-0.612 1.363-1.362s-0.613-1.362-1.363-1.362c-0.75 0-1.363 0.612-1.363 1.362 0.006 0.756 0.613 1.362 1.363 1.362zM9.931 5.981c0.375 0 0.681 0.306 0.681 0.681s-0.306 0.681-0.681 0.681c-0.375 0-0.681-0.306-0.681-0.681s0.306-0.681 0.681-0.681z"></path>
                              <path fill="#5e686b" d="M14.762 8.019c0.75 0 1.363-0.612 1.363-1.362s-0.613-1.362-1.363-1.362-1.363 0.612-1.363 1.362c0.006 0.756 0.613 1.362 1.363 1.362zM14.762 5.981c0.375 0 0.681 0.306 0.681 0.681s-0.306 0.681-0.681 0.681-0.681-0.306-0.681-0.681 0.306-0.681 0.681-0.681z"></path>
                              <path id="svg-ico" fill="#a0ce4e" d="M15.975 16.719c-2.438 0-4.419 1.981-4.419 4.419s1.981 4.419 4.419 4.419c2.438 0 4.419-1.981 4.419-4.419s-1.988-4.419-4.419-4.419zM15.975 24.875c-2.063 0-3.737-1.675-3.737-3.738s1.675-3.738 3.738-3.738c2.063 0 3.738 1.675 3.738 3.738s-1.675 3.738-3.738 3.738z"></path>
                              <path id="svg-ico" fill="#a0ce4e" d="M15.975 20.081c-0.188 0-0.338 0.15-0.338 0.337v2.038c0 0.188 0.15 0.337 0.338 0.337s0.338-0.15 0.338-0.337v-2.038c0-0.188-0.15-0.337-0.338-0.337z"></path>
                              <path id="svg-ico" fill="#a0ce4e" d="M13.869 16.363c0.188 0 0.338-0.15 0.338-0.337v-1.35c0-0.556 0.456-1.012 1.019-1.012h1.5c0.563 0 1.019 0.456 1.019 1.012v1.35c0 0.188 0.15 0.337 0.337 0.337s0.337-0.15 0.337-0.337v-1.35c0-0.931-0.762-1.694-1.694-1.694h-1.5c-0.938 0-1.694 0.762-1.694 1.694v1.35c-0.006 0.188 0.15 0.337 0.338 0.337z"></path>
                            </svg>
                          </Ico>
                          </Img>
                          <Inform>
                            <ServiceHeading3v>                            
                                <Link to="/certificados-digitales-ssl-san-ucc/">Certificados SSL SAN Colombia</Link>                            
                            </ServiceHeading3v>
                            <ServiceText>Los Certificados SSL SAN permiten proteger varios dominios con un solo certificado.</ServiceText>
                          </Inform>                        
                      </HelpContainer>
                    </AnimationContainer>
                  </Col>
                  <Col md={6}>
                    <AnimationContainer animation="fadeInDown" delay={500}>
                      <HelpContainer>
                        <BadgeGreyR><FontAwesomeIcon icon={faArrowRight} size="1x" /></BadgeGreyR>                        
                          <Img>
                          <Ico>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 32 32" alt="Certificados SSL GeoTrust">
                              <title>security</title>
                              <path fill="#5e686c" d="M15.931 31.688c-0.063 0-0.119-0.012-0.175-0.038-0.537-0.244-13.088-6.113-13.088-13.613v-13.188c0-0.006 0-0.013 0-0.025 0-0.006 0-0.019 0-0.025 0-0.231 0.2-0.444 0.425-0.412 0.081-0.013 8.75 0.037 12.55-3.844 0 0 0 0 0 0s0 0.006 0 0c0.031-0.031 0.063-0.056 0.1-0.075 0 0-0.006 0 0 0 0 0 0 0 0 0v0 0 0c0.063-0.031 0.15-0.050 0.2-0.050 0 0 0 0 0 0v0c0.063 0 0.125 0.013 0.181 0.044 0 0 0 0 0 0s0 0 0 0c0.038 0.019 0.075 0.044 0.106 0.075 0 0 0 0 0 0s0 0 0 0 0.006 0 0.006 0.006c3.631 3.706 12.281 3.838 13.156 3.844 0.25-0.050 0.494 0.156 0.494 0.412v13.244c0 7.506-13.225 13.369-13.787 13.619-0.056 0.019-0.113 0.025-0.169 0.025zM3.5 5.219v12.819c0 6.525 10.931 12.044 12.438 12.775 1.556-0.719 13.113-6.244 13.113-12.775v-12.819c-1.881-0.031-9.375-0.381-13.106-3.806-3.688 3.406-10.644 3.769-12.444 3.806z"></path>
                              <path id="svg-ico" fill="#a0ce4e" d="M15.912 27.275c-0.056 0-0.119-0.012-0.175-0.038-0.394-0.175-9.631-4.413-9.631-9.913v-8.55c0-0.231 0.188-0.419 0.419-0.419s0.419 0.188 0.419 0.419v8.556c0 4.594 7.737 8.475 8.975 9.069 1.294-0.581 9.6-4.481 9.6-9.069v-8.556c0-0.231 0.188-0.419 0.419-0.419s0.419 0.188 0.419 0.419v8.556c0 5.506-9.856 9.738-10.281 9.913-0.050 0.025-0.106 0.031-0.162 0.031z"></path>
                              <path id="svg-ico" fill="#a0ce4e" d="M6.569 8.838c-0.037 0-0.069 0-0.081 0-0.231-0.006-0.412-0.194-0.412-0.425 0.006-0.231 0.169-0.406 0.425-0.412 0.056 0 6.15 0.044 9.162-3.050 0.162-0.162 0.425-0.169 0.594-0.006 0.163 0.162 0.169 0.425 0.006 0.594-3.106 3.188-8.912 3.3-9.694 3.3z"></path>
                              <path id="svg-ico" fill="#a0ce4e" d="M25.825 8.838c-0.837 0-7.056-0.113-10.162-3.3-0.162-0.162-0.156-0.431 0.006-0.594s0.431-0.156 0.594 0.006c3.012 3.094 9.569 3.044 9.637 3.050 0 0 0.006 0 0.006 0 0.231 0 0.413 0.181 0.419 0.412s-0.181 0.419-0.413 0.425c-0.019 0-0.044 0-0.087 0z"></path>
                              <path fill="#5e686c" d="M9.613 11.838c-0.106 0-0.213-0.044-0.294-0.125-0.162-0.162-0.162-0.425 0-0.594l0.881-0.881c0.162-0.162 0.425-0.162 0.594 0 0.162 0.162 0.162 0.425 0 0.594l-0.881 0.881c-0.088 0.081-0.194 0.125-0.3 0.125z"></path>
                              <path fill="#5e686c" d="M9.169 15.806c-0.106 0-0.213-0.044-0.294-0.125-0.162-0.162-0.162-0.425 0-0.594l4.856-4.85c0.162-0.162 0.425-0.162 0.594 0 0.162 0.162 0.162 0.425 0 0.594l-4.856 4.856c-0.081 0.081-0.188 0.119-0.3 0.119z"></path>
                            </svg>
                          </Ico>
                          </Img>
                          <Inform>
                            <ServiceHeading3>                            
                                <Link to="/ssl-geotrust">Certificados SSL GeoTrust</Link>                            
                            </ServiceHeading3>
                            <ServiceText>GeoTrust, líder mundial en seguridad SSL, ofrece gran confianza y máxima seguridad.</ServiceText>
                          </Inform>                        
                      </HelpContainer>
                    </AnimationContainer>
                  </Col>
                </ServiceRow>
              </ServiceWrap>
            </Container>
          </Section>
        )
    }

}

const Iconos = (props) => (
    <StaticQuery
      query={graphql`
      query {
        background: file(relativePath: {eq: "background-poly.jpg"}) {
          childImageSharp {
            fluid(maxWidth: 2000, quality: 100) {
              src
            }
          }
        }
        webexpertIcon: file(relativePath: {eq: "icons/mobile.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        mobileIcon: file(relativePath: {eq: "icons/SSL.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
        seoIcon: file(relativePath: {eq: "icons/network.png"}) {
          childImageSharp {
            fluid(maxWidth: 500) {
              src
            }
          }
        }
      }
      `}
      render={({ 
        background, 
        webexpertIcon, 
        mobileIcon, 
        seoIcon}) => <Hosting  
        background={background} 
        webexpertIcon={webexpertIcon} 
        mobileIcon={mobileIcon} 
        seoIcon={seoIcon}
        {...props} />}
    />
  );
  export default Iconos;

